export const getUserLanguage = (language) => {
    const languageMappings = {
        en: "English",
        "en-GB": "English (UK)",
        "en-US": "English (US)",
        es: "Spanish",
        pt: "Portuguese",
        de: "German",
        fr: "French",
        hi: "Hindi",
        ja: "Japanese"
        // Add other languages as needed
    };
    return languageMappings[language];
}